// test620
(620 && 0);
